import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputSwitch} from "primereact/inputswitch";
import {ColorPicker} from "primereact/colorpicker";
import { AutoComplete } from 'primereact/autocomplete';

const CompilancecategoryFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    color: '#FFFFFF',
    has_validity: false
  });
  const [employees, setEmployees] = useState([]);
  const [notifiedEmployeeDisplay, setNotifiedEmployeeDisplay] = useState("");
  const [notifiedEmployeeSuggestions, setNotifiedEmployeeSuggestions] = useState([]);
  const [notifiedEmployeeError, setNotifiedEmployeeError] = useState(null);
  const formRef = useRef(null);


  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };

  const getErrorText = (value) => {
    if (value === null || value === undefined) {
      return '';
    }
    if (Array.isArray(value)) {
      return getErrorText(value[0]);
    }
    if (typeof value === 'object') {
      return getErrorText(Object.values(value)[0]);
    }
    return String(value);
  };

  const handleSubmitError = (error) => {
    const fieldErrors = error.response?.data?.data;
    if (error.response?.status === 400 && fieldErrors?.notified_employee) {
      setNotifiedEmployeeError(getErrorText(fieldErrors.notified_employee));
      window.App.toastShow('error', t('error'), error.toString(), '');
      return;
    }
    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    setNotifiedEmployeeError(null);
    if ((window.App.urlVars().compilanceCategoryId) || (entity === 'compilance-category' && id)) {
      apiCall('patch', '/api/v2/employee-compliance-category/' + id, data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCompilancecategoryList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          handleSubmitError(error);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employee-compliance-category', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCompilancecategoryList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/hr/compilance-category/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          handleSubmitError(error);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const searchEmployee = (event) => {
  const query = (event.query || "").toLowerCase().trim();

  if (!query) {
    setNotifiedEmployeeSuggestions([]);
    return;
  }
  const filtered = employees
    .filter(emp => {
      const name = (emp.name || "").toLowerCase();
      return name.includes(query);
    })
    .map(emp => ({
      ...emp,
      name: emp.name
    }));

  setNotifiedEmployeeSuggestions(filtered);
};



  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/employee')
      .then(response => {
        setEmployees(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().compilanceCategoryId) || (entity === 'compilance-category' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/employee-compliance-category/' + (window.App.urlVars().compilanceCategoryId ?? id))
        .then(response => {
          setFormData(response.data.data)
          const emp = response.data.data?.notified_employee;
          if (emp) {
            setNotifiedEmployeeDisplay(emp.name || "");
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.employeeName) {
      const decodedName = decodeURIComponent(urlVars.employeeName);
      setNotifiedEmployeeDisplay(decodedName);
      setNotifiedEmployeeError(null);
      setFormData((prev) => ({
        ...prev,
        notified_employee: urlVars.employeeId,
      }));
      if (formRef.current) {
        formRef.current.change('notified_employee', urlVars.employeeId);
      }
    }
  }, [window.App.urlVars().employeeName]);


  return (
    <div className={"compilance-category-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting, form}) => {
            formRef.current = form;
        return (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="color" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="color"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldColor')}</label>
                  <span className="p-d-block">
                    <ColorPicker id="color" {...input}
                                 value={formData.color}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     color: '#' + e.target.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="has_validity" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="has_validity"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldHasValidity')}</label>
                  <span className="p-d-block">
                     <InputSwitch
                       className={"p-mt-1"}
                       checked={formData.has_validity}
                       value={formData.has_validity}
                       onChange={e => setFormData({...formData, has_validity: e.target.value})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}></div>

            {formData.has_validity && (
              <>
              <div className={"p-col-12 p-lg-6"}>
                <Field name="notify_before" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="notify_before"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNotifyBefore')}</label>
                    <span className="p-d-block">
                        <InputNumber id="notify_before" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      notify_before: e.value
                                    })
                                  }}
                                  value={formData.notify_before}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <Field name="notified_employee" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="notified_employee"
                          className={classNames({'p-error': isFormFieldValid(meta) || notifiedEmployeeError})}>{props.t('fieldNotifiedEmployee')}</label>
                    <span className="p-inputgroup">
                      <Button
                        type="button"
                        className="p-button"
                        onClick={() => {
                          let _params = "?";
                          Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                            _params += key + "=" + value + "&";
                          });
                          _params += "search=employee";
                          history.push(window.location.hash.replace("#", "") + _params);
                        }}
                      >
                        <i className="pi pi-search"></i>
                      </Button>
                      <AutoComplete
                        id="notified_employee"
                        value={notifiedEmployeeDisplay}
                        suggestions={notifiedEmployeeSuggestions}
                        completeMethod={searchEmployee}
                        field={"name"}
                        delay={800}
                        forceSelection
                        placeholder={t('typeToSearchPlaceholder')}
                        className={classNames({'p-invalid': isFormFieldValid(meta) || notifiedEmployeeError})}
                        onSelect={(e) => {
                          setNotifiedEmployeeDisplay(e.value.name);
                          setNotifiedEmployeeError(null);
                          input.onChange(e.value.id);

                          setFormData({
                            ...formData,
                            notified_employee: e.value.id
                          });
                        }}
                        onChange={(e) => {
                          setNotifiedEmployeeDisplay(e.value);
                          setNotifiedEmployeeError(null);
                          input.onChange(null);
                          setFormData({
                            ...formData,
                            notified_employee: null
                          });
                        }}
                        onClear={() => {
                          setNotifiedEmployeeDisplay("");
                          setNotifiedEmployeeError(null);
                          input.onChange(null);
                          setFormData({
                            ...formData,
                            notified_employee: null
                          });
                        }}
                      />
                    </span>
                    {notifiedEmployeeError && <small className="p-error p-d-block">{notifiedEmployeeError}</small>}
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              </>
            )}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'compilance-category' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}}/>
    </div>
  )
}
export default withTranslation('common')(CompilancecategoryFormComponent);
